import React from 'react';
import { Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';

export interface OverlayOverrideMessageProps {
  message?: string;
}

const defaultOverride = intl.formatMessage({
  defaultMessage: 'This criteria is overridden.',
  id: 'EcuA5X',
});

export const OverlayOverrideMessage: React.FC<OverlayOverrideMessageProps> = ({ message }) => (
  <Text data-component="OverlayOverrideMessage" appearance="bodyXSmallBold" color="secondary">
    {message ?? defaultOverride}
  </Text>
);

export const DashboardOverridenMessage = () => (
  <OverlayOverrideMessage
    data-component="DashboardOverridenMessage"
    message={intl.formatMessage({ defaultMessage: 'Added from dashboard.', id: '+WSSln' })}
  />
);
